import { Action } from '../../infra/types'
import { RealtimeActions } from './realtime.actions'
import { RealtimeState, IRealtimeState } from './realtime.state'

export const RealtimeReducer = (
  state: IRealtimeState = RealtimeState,
  action: Action<any>
): IRealtimeState => {
  switch (action.type) {
    case RealtimeActions.SET_PUSH_SUPPORTED: {
      return { ...state, supported: action.payload }
    }
    case RealtimeActions.SET_PUSH_PERMISSION: {
      return { ...state, permission: action.payload }
    }
    case RealtimeActions.SHOW_PUSH_NUDGE: {
      return { ...state, nudgeVisible: true }
    }
    case RealtimeActions.DISMISS_PUSH_NUDGE: {
      return { ...state, nudgeVisible: false }
    }
    case RealtimeActions.SET_PUSH_REGISTERED: {
      return {
        ...state,
        registered: true,
        deviceId: action.payload.deviceId,
        nudgeVisible: false
      }
    }
    default: {
      return state
    }
  }
}
